import { useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';

const IconRenderer = ({ selector, fallback, className, ...props }) => {
  const icon = useSelector(selector);

  const transform = (node) => {
    if (node.name === 'svg') {
      Object.assign(node.attribs, { class: className, viewBox: node.attribs.viewbox, ...props });
    }
  };

  return icon ? ReactHtmlParser(icon, { transform }) : fallback;
};

export default IconRenderer;
